import React, { forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';


const Step3 = forwardRef((props, ref) => {
  const audioRef = React.useRef(null);
  const [funcionamientoSonido, setFunctionamientoSonido] = React.useState(null);
  const [progresoEjecucionSonido, setProgresoEjecucionSonido] = React.useState(0);

  useImperativeHandle(ref, () => ({
    getFuncionamientoSonido() {
      return funcionamientoSonido
    }
  }));

  const ejecutarSonido = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setProgresoEjecucionSonido(0);
      setFunctionamientoSonido(false);
      const idIntervalo = setInterval(function() {
        setProgresoEjecucionSonido(progresoEjecucionSonido => {
          if (progresoEjecucionSonido >= 100) {
            clearInterval(idIntervalo);
            console.log("Audio terminado");
            return 100;
          }
          return progresoEjecucionSonido + 10}
        )
      }, 1000)
    }
  };

  const avanzar = () => {
    setFunctionamientoSonido(true);
    setTimeout(function() {
      props.handleNext();
    }, 500);
  };

  const avanzarConError = () => {
    setFunctionamientoSonido(false);
    setTimeout(function() {
      props.handleNext();
    }, 500);
  };

  const init = async () => {

  }

  React.useEffect(() => {
    init();
  }, []);

  return (
    <div style={{ minHeight: "70vh" }}>
      <h2>Verificación de sonido</h2>
      <p>Haz clic en el siguiente botón para iniciar la prueba de sonido</p>
      <Button variant="contained" color="primary" onClick={ejecutarSonido}>
        Probar
      </Button>
      <audio ref={audioRef} src="/test-compatibilidad/piano.mp3" />
      <LinearProgress color="info" variant="determinate" value={progresoEjecucionSonido} style={{ margin: "25px" }} />
      {progresoEjecucionSonido >= 100 ?
      <div>
        <h3>¿Escuchaste correctamente?</h3>
        <Button variant="contained" color="primary" onClick={avanzar} style={{ marginLeft: "10px", marginRight: "10px", fontSize: "12px" }}>
          Sí
        </Button>
        <Button variant="contained" color="primary" onClick={ejecutarSonido} style={{ marginLeft: "10px", marginRight: "10px", fontSize: "12px" }}>
          No
        </Button>
        <Button variant="outlined" color="secondary" onClick={avanzarConError} style={{ marginTop: "25px", marginLeft: "10px", marginRight: "10px", fontSize: "12px" }}>
          No estoy seguro, quiero ir al siguiente paso
        </Button>
      </div>
      :
      <span></span>}
      
    </div>
  );
});

export default Step3;